(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('video[data-sudp-autoplay]').forEach((video) => {
      video.autoplay = false;
      let userPaused = false;
      let observerPaused = false;
      video.addEventListener('pause', () => { if (!observerPaused && !video.ended) userPaused = true; });
      video.addEventListener('play', () => { userPaused = false; });
      if (!('IntersectionObserver' in window) || reduceMotion.matches) return;
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !document.hidden && !userPaused) {
            observerPaused = false;
            video.play().catch(() => {});
          } else if (!entry.isIntersecting && !video.paused) {
            observerPaused = true;
            video.pause();
          }
        });
      }, { threshold: .2 }).observe(video);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && !video.paused) { observerPaused = true; video.pause(); }
      });
    });
    if (!desktop.matches) return;
    document.documentElement.classList.add('su-desktop-ready');
    const wrapper = document.querySelector('.page-wrapper');
    const back = document.querySelector('.senseuni-back-to-top');
    let scheduled = false;
    const updateBack = () => {
      scheduled = false;
      const y = Math.max(window.scrollY, wrapper?.scrollTop || 0);
      back?.classList.toggle('is-desktop-visible', y > 600);
    };
    const onScroll = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateBack);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    wrapper?.addEventListener('scroll', onScroll, { passive: true });
    updateBack();
    const deploy = document.getElementById('two-ways-to-deploy');
    const proof = document.querySelector('.su-proof-wrap')?.closest('.shopify-section');
    if (deploy && proof) proof.after(deploy.closest('.shopify-section') || deploy);
    const modelPaths = new Set(['/pages/for-operators']);
    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      if (modelPaths.has(url.pathname) && /compare.*models/i.test(link.textContent)) {
        url.hash = 'yepzi-models-comparison';
        link.href = url.pathname + url.search + url.hash;
      }
      if (url.pathname === '/pages/for-operators' && url.hash === '#compare-models') {
        link.href = url.pathname + url.search + '#yepzi-models-comparison';
      }
      if (url.pathname === '/pages/request-a-quote') {
        const title = document.querySelector('[data-sudp-product] h1')?.textContent.trim();
        if (title) { url.searchParams.set('model', title); url.searchParams.set('interest', 'yepzi'); }
        else if (location.pathname === '/pages/for-oems-brands') url.searchParams.set('interest', 'kit');
        else if (/partner/i.test(link.textContent)) url.searchParams.set('interest', 'partner');
        link.href = url.pathname + url.search + url.hash;
      }
    });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      let id;
      try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      const destination = new URL(location.href);
      destination.hash = url.hash;
      history.pushState(null, '', destination.pathname + destination.search + destination.hash);
      target.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
    document.querySelectorAll('.su-custom-range').forEach((range) => {
      const row = range.closest('.senseuni-slider-row');
      const tag = row?.querySelector('.senseuni-tag-num');
      if (!tag || row.querySelector('.su-desktop-number')) return;
      const input = document.createElement('input');
      input.type = 'number';
      input.className = 'su-desktop-number';
      input.min = range.min;
      input.max = range.max;
      input.step = range.step;
      input.value = range.value;
      input.setAttribute('aria-label', range.getAttribute('aria-label'));
      const unit = document.createElement('span');
      unit.className = 'su-desktop-unit';
      unit.textContent = range.id.includes('aov') ? 'USD' : range.id.includes('margin') ? '%' : range.id.includes('orders') ? '/ day' : 'Units';
      tag.dataset.numberControl = '';
      tag.before(input, unit);
      range.addEventListener('input', () => { input.value = range.value; });
      const updateNumber = (normalize) => {
        const value = Number(input.value);
        const min = Number(range.min), max = Number(range.max), step = Number(range.step);
        if (!input.value || !Number.isFinite(value)) {
          if (normalize) input.value = range.value;
          return;
        }
        if (!normalize && (value < min || value > max)) return;
        range.value = String(min + Math.round((Math.min(max, Math.max(min, value)) - min) / step) * step);
        if (normalize) input.value = range.value;
        range.dispatchEvent(new Event('input', { bubbles: true }));
      };
      input.addEventListener('input', () => { updateNumber(false); });
      input.addEventListener('change', () => { updateNumber(true); });
      input.addEventListener('blur', () => { updateNumber(true); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
